import { NgModule, APP_INITIALIZER } from "@angular/core";
import { CommonModule } from "@angular/common";
import "d3";
import "nvd3";

import { MenuItems } from "./menu-items/menu-items";
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective,
} from "./accordion";
import { ToggleFullscreenDirective } from "./fullscreen/toggle-fullscreen.directive";
import { CardRefreshDirective } from "./card/card-refresh.directive";
import { CardToggleDirective } from "./card/card-toggle.directive";
import { CardComponent } from "./card/card.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ParentRemoveDirective } from "./elements/parent-remove.directive";
import { SqueezeBoxModule } from "squeezebox";
import { PaginationModule } from "ngx-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SpinnerComponent } from "../spinner/spinner.component";
import { ModalAnimationComponent } from "./modal-animation/modal-animation.component";
import { ModalBasicComponent } from "./modal-basic/modal-basic.component";
import { ScrollModule } from "../scroll/scroll.module";
import { ToastyModule } from "ng2-toasty";
import { SimpleNotificationsModule } from "angular2-notifications";
import { TagInputModule } from "ngx-chips";
import { AnimatorModule } from "css-animator";
import { DatepickerModule } from "angular2-material-datepicker";
import { ColorPickerModule } from "ngx-color-picker";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { Ng2MaskModule } from "ng2-mask";
import { SelectModule } from "ng-select";
import { SelectOptionService } from "./elements/select-option.service";
import { FormWizardModule } from "angular2-wizard";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { QuillEditorModule } from "ngx-quill-editor";
import { DataFilterPipe } from "./elements/data-filter.pipe";
import { NameFilterPipe } from "./elements/data-filter.pipe";
import { RowFilterPipe } from "./elements/data-filter.pipe";
import { DataTableModule } from "angular2-datatable";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";
import { FileUploadModule } from "ng2-file-upload";
import { AgmCoreModule } from "@agm/core";
import { Ng2GoogleChartsModule } from "ng2-google-charts";
import { AngularEchartsModule } from "ngx-echarts";
import { UiSwitchModule } from "ng2-ui-switch/dist";
import { ChartModule } from "angular2-chartjs";
import { KnobModule } from "ng2-knob";
import { ChartistModule } from "ng-chartist";
import { NvD3Module } from "ng2-nvd3";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { TodoService } from "./todo/todo.service";
import { ClickOutsideModule } from "ng-click-outside";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { ChartsModule } from "ng2-charts";
import { VirtualScrollModule } from "angular2-virtual-scroll";
import {
  RegisCamFilterPipe,
  UserNameFilterPipe,
  GroupFilterPipe,
  PlateFilterPipe,
  UniFilterPipe,
} from "./elements/data-filter.pipe";
import { NgxImageGalleryModule } from "ngx-image-gallery";
import { InfiniteScrollModule } from "angular2-infinite-scroll";
import { TranslateService } from "../translate.service";
import { TranslatePipe } from "../translate.pipe";
import { GetipService } from "./getip/getip.service";

export function setupTranslateFactory(service: TranslateService): Function {
  return () => service.use("en");
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    PaginationModule.forRoot(),
    SqueezeBoxModule,
    ScrollModule,
    ToastyModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    TagInputModule,
    UiSwitchModule,
    AnimatorModule,
    DatepickerModule,
    ColorPickerModule,
    SelectModule,
    Ng2MaskModule,
    CurrencyMaskModule,
    FormWizardModule,
    NgxDatatableModule,
    DataTableModule,
    QuillEditorModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    FileUploadModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCE0nvTeHBsiQIrbpMVTe489_O5mwyqofk",
    }),
    Ng2GoogleChartsModule,
    AngularEchartsModule,
    ChartModule,
    KnobModule,
    ChartistModule,
    NvD3Module,
    ClickOutsideModule,
    Ng2AutoCompleteModule,
    AngularMultiSelectModule,
    ChartsModule,
    VirtualScrollModule,
    NgxImageGalleryModule,
    InfiniteScrollModule,
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ParentRemoveDirective,
    CardComponent,
    SpinnerComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    NameFilterPipe,
    RegisCamFilterPipe,
    UserNameFilterPipe,
    RowFilterPipe,
    GroupFilterPipe,
    PlateFilterPipe,
    UniFilterPipe,
    TranslatePipe,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ParentRemoveDirective,
    CardComponent,
    SpinnerComponent,
    SqueezeBoxModule,
    NgbModule,
    PaginationModule,
    FormsModule,
    ReactiveFormsModule,
    ModalBasicComponent,
    ModalAnimationComponent,
    ScrollModule,
    ToastyModule,
    SimpleNotificationsModule,
    TagInputModule,
    UiSwitchModule,
    AnimatorModule,
    DatepickerModule,
    ColorPickerModule,
    SelectModule,
    Ng2MaskModule,
    CurrencyMaskModule,
    FormWizardModule,
    NgxDatatableModule,
    DataTableModule,
    DataFilterPipe,
    QuillEditorModule,
    FroalaEditorModule,
    FroalaViewModule,
    FileUploadModule,
    AgmCoreModule,
    Ng2GoogleChartsModule,
    AngularEchartsModule,
    ChartModule,
    KnobModule,
    ChartistModule,
    NvD3Module,
    ClickOutsideModule,
    Ng2AutoCompleteModule,
    AngularMultiSelectModule,
    ChartsModule,
    VirtualScrollModule,
    NameFilterPipe,
    RegisCamFilterPipe,
    UserNameFilterPipe,
    NgxImageGalleryModule,
    RowFilterPipe,
    InfiniteScrollModule,
    GroupFilterPipe,
    PlateFilterPipe,
    UniFilterPipe,
    TranslatePipe,
  ],
  providers: [
    MenuItems,
    TodoService,
    SelectOptionService,
    GetipService,
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true,
    },
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/shared/shared.module.ts